import { debugLog } from 'lib/utils/debug-logging';

export interface DataLayerEvent {
  event: string;
  [key: string]: string | number | boolean | string[] | null | undefined;
}

export const pushToDataLayer = (event: DataLayerEvent): void => {
  if (typeof window === 'undefined') return;
  try {
    const w = window as Window & { dataLayer?: DataLayerEvent[] };
    w.dataLayer ??= [];
    w.dataLayer.push(event);
    debugLog('analytics', 'data layer push:', event);
  } catch {
    console.error('GTM push failed', event);
  }
};
